import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  gtmId: 'GTM-WC47ZCJ'
}

export default function GTM(){
  return (
    TagManager.initialize(tagManagerArgs)
  );
}